package com.essntl.features.message.ui.client_profile

sealed interface ClientProfileNavigation {
    data class NavigateToItinerary(val itineraryId: String) : ClientProfileNavigation
}